const formatAMPM = (hours: number, minutes: number) => {
  const AMorPM = hours >= 12 ? 'PM' : 'AM';
  let newHours = hours % 12;
  newHours = newHours ? newHours : 12;
  const newMinutes = minutes < 10 ? `0${minutes}` : minutes;
  return `${newHours}:${newMinutes} ${AMorPM}`;
};

export default formatAMPM;
